module.exports = __webpack_public_path__ + "static/img/invite-success.31bbe83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/invite-success.png
// module id = yObH
// module chunks = 215